<template>
  <div class="wt2-producing-page wt2-sg">
    <producing-content
      :video="video"
      :is-video-failed="isVideoFailed"
      @stopListening="$_stopListening"
    />
    <!-- "Get the Wochit Go app" promo. Lives as a child of the producing page,
         so it mounts/unmounts with it and disappears when the page redirects. -->
    <producing-promo-banner />
  </div>
</template>

<script>
import app from 'app';
import ProducingContent from 'v/Producing/ProducingContent.vue';
import ProducingPromoBanner from 'v/Producing/ProducingPromoBanner.vue';
import Analytics from 'c/WtAnalytics';

export default {
  components: {
    ProducingContent,
    ProducingPromoBanner,
  },

  props: {
    video: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      pendingState: false,
      isVideoFailed: false,
    };
  },

  computed: {
    firebasePath() {
      return `/users/${app.rootStore.getters['user/id']}/stories/${this.video.id}/video/production`;
    },
  },

  created() {
    this.initProducing();
  },

  beforeDestroy() {
    if (this.pendingState) {
      this.$_stopListening();
      this.$_unSubscribeHandlerNotification();
    }
  },

  methods: {
    initProducing() {
      if (this.video.failed) {
        this.failedProducing();
      } else if (this.video.inProducing) {
        this.$_startListening();
      } else {
        this.finishProducing();
      }
    },

    finishProducing() {
      this.$_stopListening();

      app.navigate('videos/{0}'.format(this.video.id), {
        trigger: true,
        closeModals: false,
      });
    },

    failedProducing() {
      this.$_stopListening();

      Analytics.trigger('analytics:publishScreen:viewedFailedProduce', {
        VideoID: this.video.id,
      });

      this.isVideoFailed = true;
    },

    $_startListening() {
      this.pendingState = true;

      this.$_pendingPromise = new _.ColdPromise();
      this.$_pendingPromise.then(this.finishProducing, this.failedProducing);

      this.$_timeout = new app.namespace.Util.Timer(() => {
        this.$_pendingPromise.reject('TIMEOUT');
      }, app.TIME.minute(20));
      this.$_timeout.start();

      console.log(`listening to producing: ${this.firebasePath}`);
      app.api.realTime.listenOn({
        path: this.firebasePath,
        callback: this.$_subscribeHandler.bind(this),
        errorCallback: this.$_stopListening,
      });

      // to block notification if needed
      app.notificationController.subscribe(
        this.$_subscribeHandlerNotification,
        {
          events: ['VIDEO_PUBLISHED'],
          priority: 1, // @note: higher then NotificationFeedback
        }
      );
    },

    $_subscribeHandler({ val }) {
      if (val.message === 'DONE') {
        this.$_pendingPromise.resolve();
      } else if (val.message === 'FAILED') {
        this.$_pendingPromise.reject(val.data);
      }
    },

    $_subscribeHandlerNotification(e) {
      // block message from propagate if it's from this video
      if (e.detail.data.storyId === this.video.id) {
        e.preventDefault();
        this.$_unSubscribeHandlerNotification();
      }
    },

    $_unSubscribeHandlerNotification() {
      app.notificationController.unsubscribe(
        this.$_subscribeHandlerNotification
      );
    },

    $_stopListening() {
      this.pendingState = false;
      this.$_timeout && this.$_timeout.stop && this.$_timeout.stop();
      console.log(`stop listening to producing: ${this.firebasePath}`);
      app.api.realTime.cancelListen(this.firebasePath);
    },
  },
};
</script>

<style lang="scss" scoped>
// anchor the absolutely-positioned promo banner to the producing page
.wt2-producing-page {
  position: relative;
}
</style>
